<template>
    <div>
        <ProductPointItem
            :lbl="lbl"
            :pointProduct="listProduct"
            :activeTab="activeTab"
            v-if="isHaveItem"
        ></ProductPointItem>
    </div>
</template>
<script>
import Vue from 'vue';
import ProductPointConfig from "@/core/ProductPointDetail/ProductPointConfig.js";
import ProductPointItem from "../component/ProductPointItem.vue";

export default {
    name: "ProductPointList",
    components: {
        ProductPointItem,
    },
    props: {
        lbl: Object,
        activeTab: String,
    },
    data: function() {
        return {
            isHaveItem: false,
            listProduct: [],
            pictureUrl: Vue.bzbsConfig.bzbsBlobUrl + '/config/bioderma/productPointDetail/image/',
        }
    },
    created: function() {
        this.productList();
    },
    watch: {
        activeTab: function () {
            this.productList();
        }
    },
    methods: {
        productList: function(){ 
            this.showLoading();
            ProductPointConfig.apiGetProductPoint().subscribe(res => {
                this.hideLoading();

                this.isHaveItem = true;
                var product = res;
                this.listProduct = [];
                this.listProduct = product.filter(k => k.id == this.activeTab)[0];
                console.log('list',this.listProduct)
            });
        },
        showLoading: function() {
            this.toggleLoading(true);
        },
        hideLoading: function() {
            this.toggleLoading(false);
        },
        toggleLoading: function(isLoading) {
            this.$emit("toggleLoading", isLoading);
        },
    }
}
</script>